import React from "react";
import { FlexContainer } from "src/components";
import TextStyleSelector from "../components/TextStyleSelector";
import { TextLabel } from "../../style";

export const CustomizeTextField = ({ value, onChange }) => {

    return (
        <FlexContainer>
            <TextLabel color="#612684" fontWeight="bold">  Customise Text Style </TextLabel>
            <TextLabel color="#000000" fontSize="16px" fontWeight="bold" >
               Select Font
            </TextLabel>
            <TextStyleSelector selectedFont={value} onChange={(e) => onChange(e)}/>
        </FlexContainer>
    );
};
